






























import {Component, Vue, Watch, Prop} from "vue-property-decorator";
import {IHistoryShipment} from "@/models/StoreModels";
import {namespace} from "vuex-class";
import vuescroll, {Config} from "vuescroll";
import {ops} from "@/constants/vueScrollConfig";
import HistoryCard from "@/views/components/History/HistoryCard.vue";
import DialogInfo from "@/views/Dialog/views/DialogInfo.vue";
import {HISTORY} from "@/constants/routes";

const historyModule = namespace("history");

@Component({
  name: "HistoryList",
  components: {
    HistoryCard,
    DialogInfo,
  },
})
export default class HistoryList extends Vue {
  public readonly ops: Config = ops;

  @historyModule.Getter("existMorePages")
  public existMorePages!: boolean;

  @historyModule.Getter("getShipments")
  public shipments!: IHistoryShipment;

  @historyModule.Action("loadStory")
  public loadStory!: () => Promise<any>;

  @historyModule.Action("reset")
  public reset!: () => Promise<any>;

  @Prop()
  public shipmentId!: number;

  public scrollDown() {
    const vs = this.$refs.vs as vuescroll;

    if (vs && vs.scrollTo) {
        vs.scrollTo(
          {
            y: "100%",
          },
       );
    }
  }

  public created() {
    this.reset();
    this.loadStory();
  }

  public showDialogInfo(shipmentId: number) {
    this.$router.push({
      name: HISTORY.SHIPMENT,
      params: { shipmentId: `${shipmentId}` },
    });
  }

  public hideDialogInfo() {
    this.$router.push({ name: HISTORY.START });
  }

  public loadShipments() {
    this.loadStory()
        .then(() => this.scrollDown());
  }
}

